import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportsWrapperComponent } from './reports-wrapper.component';
import { ListComponent } from './list/list.component';

import { NewReportComponent } from './new-report/new-report.component';
import { EditReportComponent } from './edit-report/edit-report.component';
import { CopyReportComponent } from './copy-report/copy-report.component';
import { RecoverReportComponent } from './recover-report/recover-report.component';

import { ReportComponent } from './report/report.component';
import { ScheduleReportComponent } from './schedule-report/schedule-report.component';

const routes: Routes = [
   {
      path: '',
      component: ReportsWrapperComponent,
      children: [
         { path: '',               component: ListComponent },

         { path: 'new',            component: NewReportComponent, },
         { path: 'edit/:id',       component: EditReportComponent },
         { path: 'copy/:id',       component: CopyReportComponent },
         { path: 'recover/:id',    component: RecoverReportComponent },

         { path: 'run/:id',        component: ReportComponent },
         { path: 'run',            component: ReportComponent  },
         { path: 'schedule/:id',   component: ScheduleReportComponent  },

         { path: '**', redirectTo: '' },
      ]
   },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule { }
